import { render, staticRenderFns } from "./df-section-recipes.vue?vue&type=template&id=18660418&"
import script from "./df-section-recipes.ts?vue&type=script&lang=js&"
export * from "./df-section-recipes.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports